import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
/**
 * Navigation skip link container
 */
export const navigationSkipLinkContainerStyles = ({ theme }) => css `
	opacity: 0;
	pointer-events: none;
	position: absolute;
	grid-area: ${NAVIGATION_GRID_AREAS.LEFT};
	justify-self: self-start;
	z-index: ${Number(theme.zIndex.menu) + 1};
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${pxToRem(theme.spacing['200'])};
	border-radius: ${theme.borderRadius.s}px;
	border: ${theme.borderWidth.m}px solid transparent;
	white-space: nowrap;
	color: ${theme.colors.buttons.textButtonPrimary};
	background-color: ${theme.colors.buttons.bgButtonPrimary};

	&:hover {
		background-color: ${theme.colors.buttons.bgButtonPrimaryHover};
	}

	&:active {
		color: ${theme.colors.buttons.textButtonPrimary};
		background-color: ${theme.colors.buttons.bgButtonPrimaryActive};
	}

	&:focus-visible {
		pointer-events: auto;
		opacity: 1;
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		left: ${pxToRem(theme.spacing['100'])};
		padding: ${pxToRem(theme.spacing['300'])};
	}

	&::before {
		content: '';
		position: absolute;

		/* NOTE: inset the border to be between the focus-visible outline and the button itself */
		inset: -${Number(theme.borderWidth.m) * 2}px;
		border-radius: ${Number(theme.borderWidth.m) + Number(theme.borderWidth.m) * 2}px;
		border: ${theme.borderWidth.m}px solid ${theme.colors.blanc.bgMainNavigation};
	}
`;
export const NavigationSkipLinkContainer = styled(Typography) `
	${navigationSkipLinkContainerStyles}
`;
